var toastr = toastr || {};

// for IE
if (typeof console === 'undefined' || typeof console.log === 'undefined') {
    console = <any> { log: function () {} };
}

var Neon = {
    Dialogs: function () {
        "use strict";
        var showModalDialog = function (options, callback) {

            options = options || {};
            options.body = options.body || "";
            var modalOptions = $.extend({ show: true }, options.modalOptions);

            var dialog = $("#modalDialog");

            if (!_.isUndefined(options.dialogClass)) {
                $(".modal-dialog").addClass(options.dialogClass);
            }
            dialog.find(".modal-dialog").html(options.body);
            dialog.modal(modalOptions);

            if (callback && typeof (callback) === "function") {
                callback();
            }
        };

        var confirmDialog = function (title, message, success) {
            var options = {
                title: title,
                body: message,
                buttons: [
                {
                    id: 'confirmDialogOk',
                    label: FRENDS.Localizations.Ok,
                    callback: function() {
                        if (success && typeof (success) === "function") {
                            success();
                        }
                    }
                },
                {
                    id: "confirmDialogCancel",
                    label: FRENDS.Localizations.Cancel
                }]
            };

            showBasicModalDialog(options);
        };

        var showBasicModalDialog = function (options) {
            var getButtonFooter = function (buttons) {
                var footer = '<div class="modal-footer" style="text-align: center">';
                _.each(buttons, function(b:any) {
                    footer += '<input class="btn btn-default" type="button" id="' + b.id + '" value="' + b.label + '">';
                });
                footer += '</div>';
                return footer;
            };
            var dialogBody =
                "<div class=\"modal-content\">" +
                    "<div class=\"modal-header\">" +
                    "<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>" +
                    "<h3>" + options.title + "</h3>" +
                    "</div>" +
                    "<div class=\"modal-body\">" +
                    "<p>" + options.body + "</p>" +
                    "</div>" +
                    getButtonFooter(options.buttons) +
                    "</div>";

            var $dialog = $(dialogBody);

            var opts = {
                body: $dialog,
                dialogClass: options.dialogClass || 'defaultDialogWidth'
            };

            showModalDialog(opts, function () {
                if (options.init) {
                    options.init();
                }
                _.each(options.buttons, function(b:any) {
                    $("#" + b.id).click(function() {
                        if (b.callback && typeof (b.callback) === "function") {
                            b.callback();
                        }
                        $("#modalDialog").modal('hide');
                    });
                });
            });
        };

        return {
            showModalDialog: showModalDialog,
            showBasicModalDialog: showBasicModalDialog,
            confirmDialog: confirmDialog
        };
    }(),
    Toasts: function () {

        var stickyOptions = {
            closeButton: true,
            timeOut: 0,
            extendedTimeOut: 0
        };

        // default options for toastr, can be overwritten with call
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "positionClass": "toast-top-right",
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "500",
            "timeOut": "1500",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };

        var showToast = function (type, msg, options) {

            options = options || {};
            options.sticky = options.sticky || false;
            options.allowHtml = options.allowHtml || false;

            var title = options.title || '';

            // in case we set allowHtml option to true. we must take care of escapes outside of this module.
            if (!options.allowHtml) {
                msg = _.escape(msg);
            }

            if (options.sticky === true) {
                options = _.extend(options, stickyOptions);
            }

            // remove our own properties from options
            options = _.omit(options, ['title', 'sticky', 'allowHtml']);
            // we cant provide empty options to toastr so combine with default set
            options = _.extend({}, toastr.options, options);

            var toast;

            switch (type) {
                case "error":
                    toast = toastr.error(msg, title, options);
                    break;
                case "success":
                    toast = toastr.success(msg, title, options);
                    break;
                case "info":
                    toast = toastr.info(msg, title, options);
                    break;
                default:
                    toast = null;
            }

            return toast;
        };

        var showError = function (msg, options) {
            return showToast("error", msg, options);
        };

        var showSuccess = function (msg, options) {
            return showToast("success", msg, options);
        };

        var showNotification = function (msg, options) {
            return showToast("info", msg, options);
        };

        return {
            error: showError,
            success: showSuccess,
            info: showNotification
        };
    }()
};

$(document).ready(function () {

    // disable cache for all jquery ajax calls
    $.ajaxSetup({ cache: false });

    // underscore template settings
    // mustache-syntax
    _.templateSettings.interpolate = /\{\{\:(.+?)\}\}/g; // for unscaped insertion, use "{{:"
    _.templateSettings.escape = /\{\{([^\:].*?)\}\}/g;
    _.templateSettings.variable = "data"; //use data for render performance

    initialize();
    setClickHandlers();

    // show flash notifications after redirect
    $(".notification").each(function () {
        var element = $(this);
        var flag = element.hasClass("error");
        if (flag === true) {
            Neon.Toasts.error(element.text(), { sticky: true });
        }
        else {
            Neon.Toasts.success(element.text(), {});
        }
    });

    $('#main').on('click', '.uploadImportFileButton', function () {
        var $fileInput = $(this).parent().find("input[type=file]");
        $fileInput.click();
        return false;
    });
    $('#main').on('change', '.submitFile', function () {
        var $fileInput: any = $(this);
        if ($fileInput[0].files.length > 0) { //files.length is 0 if the cancel button was pressed.
            var parent = $fileInput.parents('form')[0];
            var formData = new FormData();
            formData.append('file', $fileInput[0].files[0]);
            var url = parent.attributes.action.value;
            var jQueryXhr = $.ajax({
                url: url, type: 'POST', data: formData, cache: false, contentType: false, processData: false, beforeSend: function (request) {
                    request.setRequestHeader("X-XSRF-Token", document.getElementsByName('__RequestVerificationToken')[0].getAttribute('value'));
                } });
            jQueryXhr.done(function (data, textStatus, jqXhr) {
                var contentType = jqXhr.getResponseHeader('content-type') || "";
                if (contentType.indexOf('html') > -1) {
                    importDialog(data, "#importDialog", $fileInput);
                }
                if (contentType.indexOf('json') > -1) {
                    if (data.success === true) {
                        Neon.Toasts.success(data.data, {});
                    } else {
                        Neon.Toasts.error(data.errorMessage, { sticky: true });
                    }
                    $fileInput.replaceWith($fileInput.clone(true)); // Creates a new instance of the input to clear value, but keeping event handlers.
                }
            });
        }
    });

    $(".submit-form-on-change").on("change", function() {
        $(this).closest("form").submit();
    });

    $("select#TimeLimit").change(function () {
        $(this).closest("form").submit();
    });

    $("#detailsDisplayRow").click(function () {
        $(this).addClass("hidden");
        $(this).siblings("#detailsEditRow").removeClass("hidden");
    });

    $(document).ajaxError(function (e, xhr: any, settings, exception) {
        if (xhr.errorAlreadyHandled) {
            return;
        }

        var message = FRENDS.Localizations.AjaxError + exception;
        Neon.Toasts.error(message, { sticky: true });
    });



    $('.js-scheduleSelect').change();

    $(".editor-field").bind('change keydown', hideErrors);

    $('#selectallrows').change(function () {
        var checked = $(this).prop('checked');
        if (checked === true) {
            getAllGridCheckboxes().prop('checked', true);
        } else {
            uncheckAllGridCheckboxes();
        }
    });

    $('.grid').on('change', 'input[type="checkbox"]', function () {
        checkIfBatchActionButtonShouldBeVisible();
    });

    $('.js-popover').popover({
        trigger: 'hover',
        delay: {
            show: 1000
        }
    });

    $(".jsLocalizeDateTime").each(function() {
        var elem = $(this);
        var utcTimeString = elem.text();
        elem.text(moment.utc(utcTimeString).local().calendar());
        elem.attr("title", utcTimeString);
    });

    $(".jsLocalizeDuration").each(function() {
        var elem = $(this);
        var duration = elem.text();
        elem.text(moment.duration(duration).format("h [h] m [min] s [sec]"));
        elem.attr("title", duration);
    });
});

function initialize() {
    initTagEditor();
    setupRoutineActionLink(".executeRoutineAction");
    checkIfBatchActionButtonShouldBeVisible();
}

function setClickHandlers() {
    $(".submitLink").click(function () {
        $(this).parent("form").submit();
        return false;
    });

    $("#deleteAllSuccesfulButton").click(function (e) {
        e.preventDefault();

        Neon.Dialogs.confirmDialog(FRENDS.Localizations.DeleteAllSuccessful, FRENDS.Localizations.ConfirmProcessInstanceDelete, function () {
            var $form = $("#deleteAllSuccesfulButton").closest("form");
            $form.submit();
        });
    });

    $("#deleteAllFinishedButton").click(function (e) {
        e.preventDefault();

        Neon.Dialogs.confirmDialog(FRENDS.Localizations.DeleteAllFinished, FRENDS.Localizations.ConfirmProcessInstanceDelete, function () {
            var $form = $("#deleteAllFinishedButton").closest("form");
            $form.submit();
        });
    });

    $("#acknowledgeAllErrorsButton").click(function (e) {
        e.preventDefault();
        var $form = $(e.target).closest("form");
        postFormAndShowResult($form);
    });

    $('.process_instance_row td').click(function (e) {
        if (!$(this).hasClass("batchSelectionColumn") && !$(this).hasClass("actionColumn")) {
            // not checkbox or action menu column -> open view
            e.preventDefault();
            var detailsUrl = $(this).parent().attr('data-details-url');
            window.location.href = detailsUrl;
        }
    });

    $("body").on("click", ".simpleMenuLink", function (e) {

        e.preventDefault();
        var $url = $(this).attr('href');

        sendAjaxRequestAndShowResult($url, null, null, null);
    });

    function bindStorageDaysSaveClick() {
        $("#saveStorageDaysButton").click(function (event) {
            event.preventDefault();
            var $element = $("#saveStorageDaysButton");
            var $form = $element.parents("form");
            var url = $form.attr("action");
            var data = $form.serialize();
            sendAjaxRequestAndShowResult(url, function () { }, data, null);
        });
    }

    $("#storageDaysDetails").click(function () {
        var template = _.template($("#storageDaysContainer").html());
        var $element = $("#storageDaysDetails");

        var body = template({
            ProcessGuid: $element.data("unique-id"),
            ProcessInstanceHistoryStorageDays: $element.data("storage-days"),
            DefaultStorageDays: $element.data("default-days")
        });

        var options = {
            body: body,
            dialogClass: "defaultDialogWidth"
        };

        Neon.Dialogs.showModalDialog(options, bindStorageDaysSaveClick);
    });

    $('body').on('click', '.deleteLink', function () {

        var $url = $(this).attr('href');
        var confirmMessage = FRENDS.Localizations.Confirm_Delete;

        Neon.Dialogs.confirmDialog(FRENDS.Localizations.Delete, confirmMessage, function () {
            sendAjaxRequestAndShowResult($url, null, null, null);
        });

        return false;
    });

    $(".executeBatchExportAction").click(function () {

        var $fieldsContainer = $('#inputFields');
        $fieldsContainer.empty();

        var ids = getListOfIdsForSelectedItems();

        $.each(ids, function (index, value) {
            $fieldsContainer.append('<input type="hidden" name="ids" value="' + value + '" />');
        });

        var $form = $('#batchActionForm');
        $form.submit();

        $('#batchActionsButton').dropdown('toggle');

        return false;
    });

    $(".executeBatchAction").click(function () {
        batchAction($(this), { id: getListOfIdsForSelectedItems() });

        return false;
    });

    function batchAction($link, data) {
        if (!isLinkEnabledAndDisableIfIs($link)) {
            return false;
        }

        var url = $link.attr('href');

        showRoutineActionNotifier($link.text());
        sendAjaxRequestAndShowResult(url, function () { removeNotifierAndEnableLink($link); }, data, null);

        $('#batchActionsButton').dropdown('toggle');

        return false;
    }

    $(".executeRoutineInstanceTerminateAction").click(function () {
        var data = {
            id: getExecutionIdsForSelectedItems()
        };
        var $link = $(this);

        batchAction($link, data);

        return false;
    });

    $(".executeBatchActivateOrDeactivateRoutinesAction").click(function () {
        var $link = $(this);
        var data = { id: getListOfIdsForSelectedItems() };

        batchAction($link, data);

        return false;
    });

    $(".executeBatchStartRoutinesAction").click(function () {
        var $link = $(this);
        var routines = getBatchOfSelectedRoutines();

        var data = {
            items: $.map(routines, function (value) {

                return JSON.stringify({
                    UniqueId: value.id
                });

            })
        };

        batchAction($link, data);

        return false;
    });

    $("body").on("click", ".deleteBatchAction", function () {

        var $link = $(this);
        var confirmMessage = FRENDS.Localizations.Confirm_DeleteMultiple;

        $('#batchActionsButton').dropdown('toggle');

        Neon.Dialogs.confirmDialog(FRENDS.Localizations.Delete, confirmMessage, function () {
            batchAction($link, { id: getListOfIdsForSelectedItems() });
        });

        return false;
    });

    $(".batchTagAction").click(function () {
        $('#batchActionsButton').dropdown('toggle');
        batchActionDialog($(this).attr('href'), setBindingsForBatchTagView);
        return false;
    });

    $(".batchEditAction").click(function () {
        $('#batchActionsButton').dropdown('toggle');
        var urlToFetchEditDialog = $(this).attr('href');
        batchActionDialog(urlToFetchEditDialog + "/" + getListOfIdsForSelectedItems(), setBindingsForBatchEditView);
        return false;
    });

    $(".js-connectionPointCount > a").click(function () {
        var url = $(this).attr("href");

        showUsedByRoutinesDialog(url, FRENDS.Localizations.ConnectionPoints);
        return false;
    });

    $(".js-usedByLink").click(function () {

        var disabled = $(this).parent().hasClass("disabled");

        if (disabled === true) {
            return false;
        }

        var url = $(this).attr("href");

        showUsedByRoutinesDialog(url, FRENDS.Localizations.UsedByTitle);
        return false;
    });

    $(".js-actionMenu").click(function (e) {

        var $usedByLink = $(this).next().find(".js-usedByLink");
        var url = $usedByLink.attr("data-usedbycounturl");

        if (url !== undefined) {
            $.getJSON(url, function (data) {
                var count = data;
                $usedByLink.parent().removeClass("disabled");
                var text = $usedByLink.attr("data-text");
                $usedByLink.html(text + " <span class=\"badge\">" + count + "</span>");

                if (count === 0) {
                    $usedByLink.parent().addClass("disabled");
                }
            });
        }
    });

    // special case for add task button to hide "one task required" error
    $("#addNewTaskButton").bind('click', function () {
        $('#routineEditor').each(hideErrors);
    });

    initializeSaveButtonEvents("form.js-dirty-check");
}

function initializeSaveButtonEvents(formSelector) {
    $(formSelector).on('showSaveButton.Neon', function () {
        //TODO: should we use CSS animations, like Bootstrap fade?
        $(this).find('.unsaved-changes-footer').slideDown({ complete: function () { $(this).addClass("in"); } });
    });

    $(formSelector).on('hideSaveButton.Neon', function () {
        var $form = $(this);
        if ($form.hasClass("js-force-dirty")) {
            return; // form is forced dirty -> do not hide the save button
        }

        $(this).find('.unsaved-changes-footer').slideUp({ complete: function () { $(this).removeClass("in"); } });
    });
}

function setupRoutineActionLink(linkClass) {
    var linkSelector = 'table.grid ' + linkClass;
    $('#main').on('click', linkSelector,
        function () {
            var $link = $(this);
            if (!isLinkEnabledAndDisableIfIs($link)) {
                return false;
            } else {
                var url = $link.attr('href');

                var operation = $link.text();
                showRoutineActionNotifier(operation);

                sendAjaxRequestAndShowResult(url, function () {
                    removeNotifierAndEnableLink($link);
                }, null, false);

                $(this).parentsUntil(".btn-group").siblings(".dropdown-toggle").dropdown('toggle');
            }
            return false;
        });
}

function isLinkEnabledAndDisableIfIs(link) {
    // the link is disabled, do nothing
    if (link.attr('class').indexOf('disabledLink') !== -1) {
        return false;
    }

    //disable link:
    link.addClass('disabledLink');
    return true;
}

function showRoutineActionNotifier(operation) {
    // use default timeout for toast instead of removing it manually
    return Neon.Toasts.info(operation + FRENDS.Localizations.AjaxProcessOperationPending, {});
}

function removeNotifierAndEnableLink(link) {
    // only enable link
    link.removeClass('disabledLink');
}

function checkIfBatchActionButtonShouldBeVisible() {

    var count = getSelectedGridCheckboxes().length;

    if (count > 0) {
        $('#batchActionsButton').show();
    } else {
        $('#batchActionsButton').hide();
    }
}

function hideErrors() {
    var element = $(this);
    element.children('.input-validation-error').removeClass('input-validation-error');
    element.children('.field-validation-error').removeClass('field-validation-error').text('');
}

function getBatchOfSelectedRoutines() {

    var $elements = getSelectedGridCheckboxes();
    var values = [];

    $elements.each(function () {
        var id = $(this).attr('data-unique');
        var version = $(this).attr('data-version');
        var item = {
            id: id,
            version: version
        };
        values.push(item);
    });

    return values;
}

function getListOfIdsForSelectedItems() {
    return getListOfValuesForSelectedItems('data-element-id');
}

function getListOfValuesForSelectedItems(attribute) {
    var $elements = getSelectedGridCheckboxes();
    var values = [];

    $elements.each(function () {
        values.push($(this).attr(attribute));
    });

    return values;
}

function getExecutionIdsForSelectedItems() {

    var $rows = $('td input[type="checkbox"]:checked').closest('[class^="gridrow"]');
    var values = [];

    $rows.each(function () {
        values.push($(this).attr('data-execution-id'));
    });

    return values;
}

function getSelectedGridCheckboxes() {
    return $('[class^="gridrow"]').find('td input[type="checkbox"]:checked');
}

// contains column checkbox
function getAllGridCheckboxes() {
    return $('.grid').find('td input[type="checkbox"]');
}

function uncheckAllGridCheckboxes() {
    getAllGridCheckboxes().prop('checked', false);
    $('.grid').find('#selectallrows').prop('checked', false);
}

function batchActionDialog(urlToFetchTagDialog, bindingFunction) {

    $.get(urlToFetchTagDialog, function (data) {
        var options = {
            body: data,
            dialogClass: 'defaultDialogWidth'
        };

        Neon.Dialogs.showModalDialog(options, function () {
            bindingFunction();
        });
    });

    return false;
}

function setBindingsForBatchTagView() {
    initTagEditor();
    bindBatchActionDialogButtonClick($('#batchTagButton'), $('#batchTagForm'), getListOfIdsForSelectedItems());
}

function setBindingsForBatchEditView() {
    $(".select2-arrow > b").remove(); //remove select2's expander icon
    $(".select2-arrow").append("<span class='caret'></span>"); //add bootstrap style expander icon

    bindBatchActionDialogButtonClick($('#batchEditButton'), $('#batchEditForm'), getListOfIdsForSelectedItems());
}

function bindBatchActionDialogButtonClick(button, form, selectedItemIds) {
    button.click(function () {
        $('#id').val(selectedItemIds);
        var url = form.attr('action');
        var data = form.serialize();
        $("#modalDialog").modal('hide');

        sendAjaxRequestAndShowResult(url, null, data, null);
    });
}

function importDialog(importResult, dialogId, file) {
    var options = {
        body: importResult,
        modalOptions: { backdrop: 'static' },
        dialogClass: 'defaultDialogWidth'
    };

    Neon.Dialogs.showModalDialog(options, function () {
        // containerDivCopy is created and transferred so the Import-button can be pressed multiple times
        // it will be missing, if it is not cloned back,
        // because the hidden div is moved when it is preprended to the import dialog (to pass the file there)
        var importForm = $('#importForm');
        if (importForm.length > 0) {
            var containerDiv = $(file).parent();
            var containerDivCopy = containerDiv.clone(true, true);
            containerDivCopy.prependTo(containerDiv.parent());
            containerDiv.prependTo(importForm);
        }
        $("#modalDialog").one('hidden.bs.modal', function() {
            file.replaceWith(file.clone(true)); // Creates a new instance of the input to clear value, but keeping event handlers.
        });
        let importButton = $('#importButton');
        importButton.click(function () {
            var form: any = importForm[0];
            var formData = new FormData();
            for (var i = 0; i < form.length; i++) {
                var input = form[i];
                if (input.type === 'file') {
                    formData.append(input.name, input.files[0]);
                } else if (input.type === 'checkbox') {
                    if (input.checked) {
                        formData.append(input.name, input.value);
                    }
                } else {
                    formData.append(input.name, input.value);
                }
            }

            importButton.parent().prepend('<div id="pageLoadSpinner" class="show-spinner"></div>');
            importButton.attr('disabled', "true");

            var url = importForm.attr('action');
            var jQueryXhr = $.ajax({
                url: url, type: 'POST', data: formData, cache: false, contentType: false, processData: false, beforeSend: function (request) {
                    request.setRequestHeader("X-XSRF-Token", document.getElementsByName('__RequestVerificationToken')[0].getAttribute('value'));
                }});
            jQueryXhr.done(function (data, textStatus, jqXhr) {
                $("#modalDialog").modal('hide');
                if (data.success === true) {
                    Neon.Toasts.success(data.data, { onHidden: function () { location.reload(); } });
                } else {
                    Neon.Toasts.error(data.errorMessage, { sticky: true, allowHtml: true });
                    if (data.data && data.data.sourceCode) {
                        console.log("Compilation errors: ", data.data.errors, data.data.sourceCode);
                    }
                }
            }).always(() => {
                importButton.parent().find("div#pageLoadSpinner").remove();
            });
        });
    });
}

function applyDialogBindings(url, bindingFunction) {
    $.get(url, function (data) {
        var options = {
            body: data,
            dialogClass: 'defaultDialogWidth'
        };

        Neon.Dialogs.showModalDialog(options, function () {
            bindingFunction();
        });
    });

    return false;
}

function showUsedByRoutinesDialog(url, header) {

    $.get(url, function (data) {
        var options = {
            body: data,
            dialogClass: 'defaultDialogWidth'
        };

        Neon.Dialogs.showModalDialog(options, function () { });
    });

    return false;
}

function initTagEditor() {

    var $tagInput: any = $("#TagString");

    if ($tagInput.length > 0) {

        var url = $tagInput.attr('data-url');

        $tagInput.tokenfield({
            createTokensOnBlur: true,
            typeahead: {
                limit: 10,
                name: 'tags',
                prefetch: {
                    ttl: 30000,
                    url: url
                }
            }
        });
    }
}

function sendAjaxRequestAndShowResult(postUrl, doneFunction, data, refreshAfter) {

    if (typeof refreshAfter == "undefined" || refreshAfter === null) {
        refreshAfter = true;
    }

    var request = $.ajax({
        type: "POST",
        traditional: true,
        url: postUrl,
        dataType: "text",
        data: data, beforeSend: function (request) {
            request.setRequestHeader("X-XSRF-Token", document.getElementsByName('__RequestVerificationToken')[0].getAttribute('value'));
        }
    });

    if (doneFunction) {
        request.always(doneFunction);
    }

    request.done(function (result) {
        var jsonData = $.parseJSON(result);
        if (jsonData.success === true) {
            Neon.Toasts.success(jsonData.data, {
                onHidden: function () {
                    if (refreshAfter) {
                        location.reload();
                    }
                }
            });
        } else {
            Neon.Toasts.error(jsonData.errorMessage, { sticky: true });
        }
    });
}

function postFormAndShowResult($form) {
    var url = $form.attr("action");
    var data = $form.serialize();
    sendAjaxRequestAndShowResult(url, function () { }, data, null);
}

function ToggleExpander(sender) {
    var imageElem = $(sender).find('span.expanderImage');
    imageElem.toggleClass('glyphicon glyphicon-chevron-right glyphicon glyphicon-chevron-down');
    return false;
}
